import { createReducer, createTypes } from 'reduxsauce';

export const primeiroNivelTypes = createTypes(
  `
  SET_VALORES_UCHAS_EBAS
  SET_ZONAS
  SET_CLIENTES
  SET_PARQUES
  FECHA_CONEXOES
  SET_PARQUE_REALTIME
  SET_SUBSCRIPTION_HEALTH
  SET_THING_LAST_SEEN
  `,
  { prefix: 'PRIMEIRO/' }
);

const INITIAL_STATE = {
  mapa: {
    zonas: [],
    clientes: [],
    parques: [],
  },
  uchas: {},
  ebas: {},
  // Snapshot por parque dos valores em tempo real (somatorio das things
  // do parque). Usado para tooltip do marker no mapa. Chave: parqueId.
  // Forma: { [parqueId]: { onTimeUcha, vazaoUcha, potenciaEba, vazaoEba } }
  parqueRealtime: {},
  conexoes: [],
  // Saude das subscriptions GraphQL (onUpdateIOT). 'ok' quando esta
  // recebendo updates, 'failed' quando recebeu erro. Usado pra indicador
  // visual no mapa (UpdatedAgo + badge "Subscription off").
  subscriptionHealth: 'ok',
  // Timestamp da ultima leitura recebida via subscription por thingName.
  // Usado pra freshness chip per-card em /dashboard/customer. Map em
  // memoria (nao persiste — stale apos refresh ate proxima sub tick).
  thingLastSeen: {},
};

const setUchasEbas = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    uchas: { ...state.uchas, ...action.uchas },
    ebas: { ...state.ebas, ...action.ebas },
    conexoes: action.conexoes || state.conexoes,
  };
};

const setZonas = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    mapa: {
      ...state.mapa,
      zonas: action.zonas,
    },
  };
};

const setClientes = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    mapa: {
      ...state.mapa,
      clientes: action.clientes,
    },
  };
};

const setParques = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    mapa: {
      ...state.mapa,
      parques: action.parques,
    },
  };
};

const fechaConexoes = (state = INITIAL_STATE) => {
  state.conexoes.forEach((ƒ) => ƒ());
  return {
    ...state,
    conexoes: [],
    parqueRealtime: {},
  };
};

const setParqueRealtime = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    parqueRealtime: {
      ...state.parqueRealtime,
      ...action.parqueRealtime,
    },
  };
};

const setSubscriptionHealth = (state = INITIAL_STATE, action) => {
  if (state.subscriptionHealth === action.health) return state;
  return {
    ...state,
    subscriptionHealth: action.health,
  };
};

const setThingLastSeen = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    thingLastSeen: {
      ...state.thingLastSeen,
      [action.thingName]: action.ts,
    },
  };
};

export default createReducer(INITIAL_STATE, {
  [primeiroNivelTypes.SET_VALORES_UCHAS_EBAS]: setUchasEbas,
  [primeiroNivelTypes.SET_ZONAS]: setZonas,
  [primeiroNivelTypes.SET_CLIENTES]: setClientes,
  [primeiroNivelTypes.SET_PARQUES]: setParques,
  [primeiroNivelTypes.FECHA_CONEXOES]: fechaConexoes,
  [primeiroNivelTypes.SET_PARQUE_REALTIME]: setParqueRealtime,
  [primeiroNivelTypes.SET_SUBSCRIPTION_HEALTH]: setSubscriptionHealth,
  [primeiroNivelTypes.SET_THING_LAST_SEEN]: setThingLastSeen,
});
